import { Component } from '@angular/core';
import { ContactService } from '@services/contact.service';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { IAfterGuiAttachedParams, ICellRendererParams } from 'ag-grid-community';
import { AtlasGridComponent } from '../atlas-grid.component';

@Component({
  selector: 'wsb-checkbox-cell',
  template: `
    <div
      style="margin-left: 1px;"
      [ngStyle]="{ 'background-color': this.isDisabled ? '#BBBBBB' : null }"
      [ngClass]="{ 'ag-checked': select }"
      class="ag-wrapper ag-input-wrapper ag-checkbox-input-wrapper"
      role="presentation"
    >
      <input
        [disabled]="this.isDisabled"
        class="ag-input-field-input ag-checkbox-input"
        type="checkbox"
        [(ngModel)]="select"
        (change)="onChange($event)"
      />
    </div>
  `,
  standalone: false
})
export class CheckboxCellComponent implements ICellRendererAngularComp {
  public params: ICellRendererParams;
  public isDisabled = false;
  public select = false;
  page;
  selectedList;

  pages = ['send', 'contacts', 'shared'];

  constructor(private grid: AtlasGridComponent, private contactService: ContactService) {}

  refresh(params?: any): boolean {
    return true;
  }

  afterGuiAttached?(params?: IAfterGuiAttachedParams): void {
    throw new Error('Method not implemented.');
  }

  agInit(params): void {
    this.params = params;
    this.page = params.page;

    this.select = params.node.isSelected() ? true : false;

    switch (this.page) {
      case 'send':
      case 'mail':
        if (this.params?.data) {
          if (this.contactService.selectedList) {
            if (this.contactService.selectedList.has(params.data.idContact)) {
              this.params.node.setSelected(true);
              this.select = true;
            }
          }
        }

        this.grid.selectionChange.subscribe(event => {
          if (!this.params.data?.shared) {
            if (this.grid.isSelectedAll()) {
              this.isDisabled = true;
              this.select = true;
            } else if (params.rowIndex === event?.rowIndex) {
              this.isDisabled = false;
              this.select = event.node.isSelected();
            }
          }
        });

        break;
      case 'contacts':
        if (this.params?.data) {
          if (this.contactService.selectedList) {
            if (this.contactService.selectedList.has(params.data.idContact)) {
              this.params.node.setSelected(true);
              this.select = true;
            }
          }
        }

        if (this.params.data?.shared) {
          this.isDisabled = true;
        }
        this.grid.selectionChange.subscribe(event => {
          if (!this.params.data?.shared) {
            if (this.grid.isSelectedAll()) {
              this.isDisabled = true;
              this.select = true;
            } else if (params.rowIndex === event?.rowIndex) {
              this.isDisabled = false;
              this.select = event.node.isSelected();
            }
          }
        });

        break;

      default:
        if (this.params.data?.sharingInfo) {
          this.isDisabled = true;
        }
        this.grid.selectionChange.subscribe(event => {
          if (!this.params.data?.sharingInfo) {
            if (this.grid.isSelectedAll()) {
              this.isDisabled = true;
              this.select = true;
            } else if (params.rowIndex === event?.rowIndex) {
              this.isDisabled = false;
              this.select = event.node.isSelected();
            }
          }
        });
        break;
    }
  }

  public onChange(event) {
    this.params.node.setSelected(event.currentTarget.checked);
    if (this.pages.includes(this.page)) {
      if (event.currentTarget.checked) {
        this.contactService.selectedList.add(this.params.data.idContact);
      } else {
        this.contactService.selectedList.delete(this.params.data.idContact);
      }
    }
  }
}
